import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'
import { permissionDenied } from '@user/store/authorization'
import { useMemo } from 'react'
import { Props } from '../ServiceRequirements'

export function useData(props: Props) {
  const { canUpdate, leadStatus, oppStatus, servicesCount } = props

  const isComplete = servicesCount > 0

  const isDisqualifiedLead =
    !!leadStatus && leadStatus == LEAD_STATUSES.Disqualified

  const oppIsClosed =
    oppStatus == OPPORTUNITY_STATUSES.Lost ||
    oppStatus == OPPORTUNITY_STATUSES.Won

  const servicesDisabledText = useMemo(() => {
    if (!canUpdate) return permissionDenied
    if (oppIsClosed) {
      return `You cannot add services to a closed Opportunity.`
    }
    if (isDisqualifiedLead) {
      return `You cannot add services to a disqualified Lead.`
    }
  }, [canUpdate, isDisqualifiedLead, oppIsClosed])

  return {
    isComplete,
    isDisqualifiedLead,
    oppIsClosed,
    servicesDisabledText,
  }
}
